interface LogoProps {
  size?: number;
}

const Logo = ({ size = 36 }: LogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 91.092 97.219"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <defs>
        <radialGradient
          id="logo_g1"
          cx="45.9775"
          cy="49.3721"
          r="44.2525"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g2"
          cx="45.9766"
          cy="49.3726"
          r="44.2528"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g3"
          cx="45.9771"
          cy="49.3726"
          r="44.2524"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g4"
          cx="45.9771"
          cy="49.3726"
          r="44.2528"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g5"
          cx="45.9775"
          cy="49.3721"
          r="44.2525"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g6"
          cx="45.978"
          cy="49.3726"
          r="44.253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g7"
          cx="45.9771"
          cy="49.3706"
          r="44.254"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
        <radialGradient
          id="logo_g8"
          cx="45.9771"
          cy="49.3706"
          r="44.2536"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2EFFF1" />
          <stop offset="0.3193" stopColor="#33CED6" />
          <stop offset="0.7822" stopColor="#398BB2" />
          <stop offset="1" stopColor="#3C71A4" />
        </radialGradient>
      </defs>
      <g>
        <path
          fill="url(#logo_g1)"
          d="M76.971,48.609c-0.029-13.337-8.427-24.75-20.197-29.274l0.013,7.621H34.038l-0.014-7.521c-3.987,1.567-7.64,3.947-10.747,7.068c-5.922,5.948-9.174,13.846-9.156,22.241c0.027,13.27,8.342,24.632,20.021,29.202l-0.014-7.614H56.88l0.013,7.657c4.05-1.566,7.767-3.97,10.922-7.139C73.737,64.901,76.989,57.003,76.971,48.609z M57.874,60.951c-3.279,3.293-7.644,5.112-12.29,5.122h-0.037c-9.574,0-17.378-7.788-17.396-17.361c-0.011-4.646,1.789-9.019,5.068-12.311s7.645-5.112,12.293-5.121c9.608,0,17.41,7.787,17.431,17.359C62.953,53.285,61.153,57.658,57.874,60.951z"
        />
        <path
          fill="url(#logo_g2)"
          d="M90.34,69.212v-41.06C84.048,14.486,71.69,4.172,56.742,0.682l0.023,13.48c14.534,4.746,25.059,18.385,25.093,34.437c0.021,9.699-3.737,18.826-10.58,25.698c-4.098,4.115-9.012,7.119-14.375,8.876l0.022,13.376h0.334C71.985,92.946,84.125,82.714,90.34,69.212z"
        />
        <path
          fill="url(#logo_g3)"
          d="M33.834,96.55h0.339L34.15,83.142C19.726,78.355,9.267,64.753,9.233,48.753c-0.021-9.7,3.737-18.827,10.581-25.7c4.054-4.07,8.906-7.051,14.201-8.818L33.991,0.764C19.195,4.333,6.99,14.587,0.751,28.138V69.2C6.97,82.707,19.117,92.942,33.834,96.55z"
        />
        <path
          fill="url(#logo_g4)"
          d="M45.548,36.167c-3.369,0.007-6.509,1.315-8.867,3.682c-2.357,2.367-3.652,5.512-3.645,8.853c0.014,6.884,5.626,12.484,12.51,12.484v2.443l0.027-2.443c3.341-0.007,6.479-1.315,8.837-3.683c2.357-2.368,3.651-5.512,3.644-8.854C58.041,41.766,52.43,36.167,45.548,36.167z"
        />
        <path
          fill="url(#logo_g5)"
          d="M90.34,18.246V0.669H70.607C78.537,4.828,85.323,10.885,90.34,18.246z"
        />
        <path
          fill="url(#logo_g6)"
          d="M20.476,0.669H0.751v17.57C5.766,10.883,12.546,4.827,20.476,0.669z"
        />
        <path
          fill="url(#logo_g7)"
          d="M0.751,79.105V96.55h19.476C12.408,92.394,5.715,86.386,0.751,79.105z"
        />
        <path
          fill="url(#logo_g8)"
          d="M70.874,96.55H90.34V79.111C85.379,86.388,78.693,92.396,70.874,96.55z"
        />
      </g>
    </svg>
  );
};

export default Logo;
